<cam-badge [type]="this.color()" [value]="this.label() | translate"></cam-badge>
